import { render } from "./ListStaff.vue?vue&type=template&id=1841095f&scoped=true"
import script from "./ListStaff.vue?vue&type=script&lang=js"
export * from "./ListStaff.vue?vue&type=script&lang=js"

import "./ListStaff.vue?vue&type=style&index=0&id=1841095f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1841095f"]])

export default __exports__